module.exports = __webpack_public_path__ + "img/05.da879aed.png";